<div>
  @if (isLoading()) {
  <app-spinner data-test-id="usage-spinner"></app-spinner>
  } @if (signedUrl) {
  <div
    class="iframe-container"
    [style.visibility]="isLoading() ? 'hidden' : 'visible'"
  >
    <iframe
      class="responsive-iframe"
      [src]="signedUrl"
      title="Reports"
      (load)="onLoad()"
      data-test-id="usage-iframe"
    ></iframe>
  </div>
  }
</div>
